"use client";

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// 如有地址空状态图片可替换下方
import noAddress from "@/assets/images/account/no-address.webp";
import { AddAddressFormDialog, AddressList, type AddressListData } from "@/components/business/address";
import { PopLoading } from "@/components/pop-ui/pop-loading";
import { Button } from "@/components/ui/button";
import { fixModuleDrawerViewport } from "@/components/ui/module-drawer";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { useIsMobile } from "@/hooks/use-mobile";
import type { CheckoutAddressFormData } from "@/modules/checkout/types";
import { useORPC } from "@/providers/orpc-provider";
import Empty from "./components/empty";
import { ModuleTitle } from "./components/module-title";
export function AddressesModule() {
  const $ = _c(66);
  const {
    t
  } = useTranslation();
  const orpc = useORPC();
  const isMobile = useIsMobile();
  let t0;
  if ($[0] !== orpc.ec.userAddress.findAll) {
    t0 = orpc.ec.userAddress.findAll.queryOptions();
    $[0] = orpc.ec.userAddress.findAll;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data,
    isLoading,
    refetch
  } = useQuery(t1);
  let t2;
  if ($[4] !== data) {
    t2 = data || [];
    $[4] = data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const addresses = t2;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingAddressForForm, setEditingAddressForForm] = useState(null);
  let t3;
  if ($[6] !== orpc.ec.userAddress.create) {
    t3 = orpc.ec.userAddress.create.mutationOptions();
    $[6] = orpc.ec.userAddress.create;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== refetch) {
    t4 = () => {
      setDialogOpen(false);
      setEditingAddressForForm(null);
      refetch();
    };
    $[8] = refetch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = {
      ...t3,
      onSuccess: t4
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    mutateAsync: createAddress
  } = useMutation(t5);
  let t6;
  if ($[13] !== orpc.ec.userAddress.update) {
    t6 = orpc.ec.userAddress.update.mutationOptions();
    $[13] = orpc.ec.userAddress.update;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== refetch) {
    t7 = () => {
      setDialogOpen(false);
      setEditingAddressForForm(null);
      refetch();
    };
    $[15] = refetch;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      ...t6,
      onSuccess: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const {
    mutateAsync: updateAddress
  } = useMutation(t8);
  let t9;
  if ($[20] !== orpc.ec.userAddress.remove) {
    t9 = orpc.ec.userAddress.remove.mutationOptions();
    $[20] = orpc.ec.userAddress.remove;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== refetch) {
    t10 = () => {
      setDialogOpen(false);
      setEditingAddressForForm(null);
      refetch();
    };
    $[22] = refetch;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = {
      ...t9,
      onSuccess: t10
    };
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const {
    mutateAsync: deleteAddress
  } = useMutation(t11);
  let t12;
  if ($[27] !== refetch) {
    t12 = async () => {
      await refetch();
    };
    $[27] = refetch;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const handleRefresh = t12;
  let t13;
  if ($[29] !== addresses) {
    t13 = address => {
      const originalAddress = addresses.find(a => a.id === address.id);
      if (originalAddress) {
        setEditingAddressForForm(originalAddress);
        setDialogOpen(true);
      }
    };
    $[29] = addresses;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const handleEditAddress = t13;
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setEditingAddressForForm(null);
      setDialogOpen(true);
    };
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const handleAddAddress = t14;
  let t15;
  if ($[32] !== deleteAddress) {
    t15 = async addressId => {
      ;
      try {
        await deleteAddress({
          id: addressId
        });
      } catch (t16) {
        const error = t16;
        console.error("Failed to delete address:", error);
      }
    };
    $[32] = deleteAddress;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const handleDeleteAddress = t15;
  let t16;
  if ($[34] !== addresses) {
    t16 = addresses.map(_temp);
    $[34] = addresses;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const addressListData = t16;
  let t17;
  if ($[36] !== t) {
    t17 = t("account.addresses.title");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <ModuleTitle title={t17} />;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t) {
    t19 = t("account.addresses.addNewAddress");
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t19) {
    t20 = <Button variant="outline" size="sm" className="mt-[-10px] hidden border-black uppercase md:block" onClick={handleAddAddress}>{t19}</Button>;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = open => {
      setDialogOpen(open);
      if (!open) {
        setEditingAddressForForm(null);
        setTimeout(_temp2, 300);
      }
    };
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  const t22 = createAddress as any;
  const t23 = updateAddress as any;
  let t24;
  if ($[45] !== dialogOpen || $[46] !== editingAddressForForm || $[47] !== handleDeleteAddress || $[48] !== t22 || $[49] !== t23) {
    t24 = <AddAddressFormDialog isOpen={dialogOpen} onOpenChange={t21} onAddAddress={t22} onUpdateAddress={t23} onDeleteAddress={handleDeleteAddress} editingAddress={editingAddressForForm} showDelete={true} dismissible={true} />;
    $[45] = dialogOpen;
    $[46] = editingAddressForForm;
    $[47] = handleDeleteAddress;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t18 || $[52] !== t20 || $[53] !== t24) {
    t25 = <div className="flex items-center justify-between">{t18}{t20}{t24}</div>;
    $[51] = t18;
    $[52] = t20;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  const headerDom = t25;
  let t26;
  if ($[55] !== addressListData || $[56] !== addresses || $[57] !== handleEditAddress || $[58] !== headerDom || $[59] !== isLoading || $[60] !== t) {
    t26 = () => {
      if (isLoading) {
        return <div className="min-h-[500px]">{headerDom}<div className="flex items-center justify-center py-10"><PopLoading /></div></div>;
      }
      if (!addresses || addresses.length === 0) {
        return <div>{headerDom}<Empty src={noAddress} title={t("account.addresses.emptyText")} /><div className="mt-4 md:hidden"><Button variant="outline" className="w-full border-black! uppercase" onClick={handleAddAddress}>{t("account.addresses.addNewAddress")}</Button></div></div>;
      }
      return <div>{headerDom}<AddressList addresses={addressListData} selectable={false} onEditAddress={handleEditAddress} onAddAddress={handleAddAddress} variant="module" className="flex flex-col gap-3 md:gap-4" /></div>;
    };
    $[55] = addressListData;
    $[56] = addresses;
    $[57] = handleEditAddress;
    $[58] = headerDom;
    $[59] = isLoading;
    $[60] = t;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  const contentDom = t26;
  let t27;
  if ($[62] !== contentDom || $[63] !== handleRefresh || $[64] !== isMobile) {
    t27 = isMobile ? <PullToRefreshWrapper onRefresh={handleRefresh}>{contentDom()}</PullToRefreshWrapper> : contentDom();
    $[62] = contentDom;
    $[63] = handleRefresh;
    $[64] = isMobile;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  return t27;
}
function _temp2() {
  fixModuleDrawerViewport();
}
function _temp(address_0) {
  return {
    id: address_0.id || "",
    firstName: address_0.firstName,
    lastName: address_0.lastName,
    phone: address_0.phone,
    address: address_0.address,
    addressDetail: address_0.addressDetail,
    province: address_0.province,
    city: address_0.city,
    zipCode: address_0.zipCode,
    isDefault: address_0.isDefault
  };
}